import { render, staticRenderFns } from "./digital-skill.vue?vue&type=template&id=5ce798a2&"
import script from "./digital-skill.vue?vue&type=script&lang=js&"
export * from "./digital-skill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports